import PageLang from "../../utils/page-lang";
import Popup from "../../utils/popup";
import DetectMobileBrowsers from "../../utils/detect-mobile-browsers";

class PopupPustyKoszyk {
  constructor() {
    this.popupModal = $("#popup-modal");
    this.frWrapper = $(".fr-wrapper");
    this.homePageUrl = "/";
    this.translates = {
      _f0947b910aa05c58eb9bde46a59d232b: {
        pl: "Twój koszyk jest pusty!",
        en: "Your shopping cart is empty!"
      },
      _a915944edcfc421c1d04d8f46c592d96: {
        pl: "Powrót do strony głównej",
        en: "Back to main page"
      }
    };
    this.popup = null;
  }

  events() {
    const _this = this;

    this.popupModal.on("hidden.bs.modal", function() {
      window.location = _this.homePageUrl;
    });
  }

  getHTML() {
    const isMobileBrowser = DetectMobileBrowsers.check();

    if (isMobileBrowser) {
      return `<p class="fr-popup__text">${
        this.translates._f0947b910aa05c58eb9bde46a59d232b[PageLang.get()]
      }</p>
              <div class="form__section form__section--last">
                <div class="form__btns">
                  <a href="${this.homePageUrl}" class="form__btn">${
        this.translates._a915944edcfc421c1d04d8f46c592d96[PageLang.get()]
      }</a>
                </div>
              </div>`;
    } else {
      return `<p class="fr-popup__text">${
        this.translates._f0947b910aa05c58eb9bde46a59d232b[PageLang.get()]
      }</p><div class="form__section form__section--last">
            <div class="form__btns">
                    <a href="${
                      this.homePageUrl
                    }" class="form__btn--half-popup btn btn--large btn--brown">${
        this.translates._a915944edcfc421c1d04d8f46c592d96[PageLang.get()]
      }</a>
                </div>
            </div>`;
    }
  }

  init() {
    if (this.frWrapper.hasClass("d-none")) {
      this.popup = new Popup(this.getHTML(), "", true);
      this.events();
    }
  }
}

export default PopupPustyKoszyk;
